import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID,
    ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID,
    ACTION_PROJECTINVESTIGATOR_CREATE,
    ACTION_PROJECTINVESTIGATOR_SAVE,
    ACTION_PROJECTINVESTIGATOR_VALIDATE,

    IProjectInvestigatorLoadByIdAction,
    IProjectInvestigatorsLoadByProjectIdAction,
    IProjectInvestigatorLoadFailureAction,
    IProjectInvestigatorLoadSuccessAction,

    IProjectInvestigatorCreateAction,
    IProjectInvestigatorCreateFailureAction,
    IProjectInvestigatorCreateSuccessAction,

    IProjectInvestigatorSaveAction,
    IProjectInvestigatorSaveSuccessAction,
    IProjectInvestigatorSaveFailureAction,

    IProjectInvestigatorValidateAction,
    IProjectInvestigatorValidateSuccessAction,
    IProjectInvestigatorValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    ValidateSuccess,
    ValidateFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/projectInvestigator";
import { projectInvestigatorsApi } from "../services/projectInvestigators";


export const
    getProjectInvestigatorsByIdEpic = (action$): Observable<IProjectInvestigatorLoadSuccessAction | IProjectInvestigatorLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTINVESTIGATOR_LOAD_BY_ID)
            .mergeMap((action: IProjectInvestigatorLoadByIdAction) => {
                return projectInvestigatorsApi
                    .getProjectInvestigatorById(action.id)
                    .map(response =>
                        LoadSuccess(response.projectInvestigator, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProjectInvestigatorsByProjectIdEpic = (action$): Observable<IProjectInvestigatorLoadSuccessAction | IProjectInvestigatorLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTINVESTIGATORS_LOAD_BY_PROJECTID)
            .mergeMap((action: IProjectInvestigatorsLoadByProjectIdAction) => {
                return projectInvestigatorsApi
                    .getProjectInvestigatorsByProjectId(action.projectId)
                    .map(response =>
                        LoadSuccess(response.projectInvestigators, undefined, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    createProjectInvestigatorEpic = (action$): Observable<IProjectInvestigatorCreateSuccessAction | IProjectInvestigatorCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTINVESTIGATOR_CREATE)
            .mergeMap((action: IProjectInvestigatorCreateAction) => {
                return projectInvestigatorsApi
                    .createProjectInvestigator(action.personnelId, action.trialId)
                    .map(response =>
                        CreateSuccess(response.projectInvestigator, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    setProjectInvestigatorEpic = (action$): Observable<IProjectInvestigatorSaveSuccessAction | IProjectInvestigatorSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTINVESTIGATOR_SAVE)
            .mergeMap((action: IProjectInvestigatorSaveAction) => {
                return projectInvestigatorsApi
                    .setProjectInvestigator(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.projectInvestigator, response.formState, response.lookups, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    validateProjectInvestigatorEpic = (action$): Observable<IProjectInvestigatorValidateSuccessAction | IProjectInvestigatorValidateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTINVESTIGATOR_VALIDATE)
            .mergeMap((action: IProjectInvestigatorValidateAction) => {
                return projectInvestigatorsApi
                    .validateProjectInvestigator(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.projectInvestigator, response.formState, response.lookups, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



